/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';
import { ResponsiveSearchAd } from '@bingads-webui-campaign/campaign-ui-schemas';
import dynamicTextExtension from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/dynamicTextExtension';
import KoSchema from '@bingads-webui-component-legacy/ko-schema/index';
import parsedTextMaxLengthExtension from '@bingads-webui-campaign-legacy/crud-ad/viewmodel/adsEditor/parsedTextMaxLengthExtension';
import { getFinalUrlDomain } from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class ViewModel {
  constructor({
    model = null,
    isNativeAdsEnabled = false,
    isVanityUrlEnabled = false,
    IsExpandedTextAdV2Enabled = false,
    placeholders = {},
    scope = null,
    activityLogger,
  } = {}) {
    // Babel would understand the intent and do this behind the curtain but it is better not to rely on it.
    const self = this;

    this.model = model;
    this.placeholders = placeholders; // preview uses this
    this.IsExpandedTextAdV2Enabled = IsExpandedTextAdV2Enabled;
    this.scope = scope;
    this.activityLogger = activityLogger;

    const lengthCheckFields = [
      'Path1',
      'Path2',
    ];

    this.fields = _.compact([
      'Path1',
      'Path2',
      'FinalUrls',
      'TrackingUrlTemplate',
      'UrlCustomParameters',
      'FinalUrlSuffix',
      'MobileFinalUrls',
    ]);

    if (isNativeAdsEnabled) {
      this.fields.push('NativePreference');
    }

    this.isVanityUrlEnabled = isVanityUrlEnabled;
    if (isVanityUrlEnabled) {
      this.fields.push('DisplayUrl');
    }

    KoSchema.properties(this, ResponsiveSearchAd, this.fields, _.defaults(model, {
      FinalUrls: [],
    }));

    dynamicTextExtension.extend(this, lengthCheckFields);
    parsedTextMaxLengthExtension.extend(this, lengthCheckFields, 'ResponsiveSearchAd');

    this.showNativeAdPreview = ko.computed(() => {
      if (isNativeAdsEnabled) {
        return self.NativePreference.isNativePreference();
      }

      return false;
    }, this);

    if (!isVanityUrlEnabled) {
      this.DisplayUrl = ko.computed(() => {
        return getFinalUrlDomain(_.first(self.FinalUrls()));
      });
    }

    this.errorMessage = ko.computed(() => {
      if (_.isEmpty(_.result(self.Path1(), 'trim')) && !_.isEmpty(self.Path2())) {
        return i18n.get('ExpandedTextAd_Path1RequiredWhenUsingPath2');
      }

      return '';
    });

    _.each(this.fields, (field) => {
      const logChange = _.once(() => {
        if (this.activityLogger) {
          this.activityLogger.signal(`ad field change: ${field}`, 'responsive search ad editor');
        }
      });

      this[field].subscribe(() => {
        logChange();
      }, this);
    });
  }

  initPreviewTab() {
    let defaultPreviewType = 'top';

    if (this.showNativeAdPreview()) {
      defaultPreviewType = 'native';
    }

    return defaultPreviewType;
  }
}
